


















import Vue from 'vue';
import Component from 'vue-class-component';
import ChoiceService from '@/services/ChoiceService';
import { ChoiceModule } from '@/store/modules/Choice';
import { AnswerModule } from '@/store/modules/Answer';

@Component({
	props: ['question'],
})
export default class RadioQuestion extends Vue {

	private answer = '';

	private created() {
		// Load possible choices for answer
		ChoiceModule.loadChoices(this.$props.question.id);
		// Set questionId in answer
		AnswerModule.answer.questionId = this.$props.question.id;
	}

	/**
	 * get possible choices from choice module.
	 */
	get choices() {
		return ChoiceModule.choices;
	}

	/**
	 * Get choice from ChoiceModule.
	 */
	get activeChoice() {
		return ChoiceModule.choice;
	}

	/**
	 * Set choice in ChoiceModule.
	 */
	set activeChoice(value) {
		ChoiceModule.setChoice(value);
	}

	private changeValue(id: number, event: any) {
		ChoiceModule.setChoice(event.target.value);
	}
}
